export default __webpack_public_path__ + "static/media/announcement_2@2x.7bcbedbb.png";